<template>
  <div class="orderSuccess">
    <section class="main_content">
      <div
        class="order_confirmation success"
        v-if="orderDetails.orderState=='PAYMENT_SUCCESSFUL' || orderDetails.orderState=='CONFIRMED' || orderDetails.orderState=='GROUP_PURCHASE_ORDER_PLACED'"
      >
        <img src="../../assets/images/icons/check-mark-success.gif" alt="payment-success" />
        <span class="congratsText">बधाई हो !</span>
        <span class="got_order">आपका आर्डर हमें मिल गया |</span>
      </div>
      <div class="page-status-panel" v-if="orderDetails.orderState=='PAYMENT_FAILURE'">
        <div class="img-block">
          <img src="../../assets/images/icons/payment-failed.svg" alt="payment-failed" />
        </div>
        <div class="details-block">
          <h2>भुगतान असफल हुआ</h2>
          <p>
            आपका आर्डर ID :
            <span>{{orderDetails.orderId}}</span>
          </p>
        </div>
        <div class="btn-block">
          <span
            @click="goToProductDetail(orderDetails.subOrderDTOList[0].saleReferenceID,'NORMAL')"
          >पुनः प्रयास करें</span>
        </div>
      </div>
    </section>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import constant from "../../utils/constant";
import store from "../../store/store";
import { bus } from "../../main";
export default {
  name: "orderSuccess",
  data() {
    return {
      orderDetails: {},
      addressDTO: {},
      subOrderDto: [],
      orderStatus: {},
      loading: false,
      confirmation: false
    };
  },
  methods: {
    getOdersByOrderId() {
      this.loading = true;
      this.$store
        .dispatch({
          type: "orderById",
          payload: this.$route.params.orderId
        })
        .then(data => {
          this.orderDetails = data.data;
          this.loading = false;
          if (
            this.orderDetails.orderState == "PAYMENT_SUCCESSFUL" ||
            this.orderDetails.orderState == "CONFIRMED" ||
            this.orderDetails.orderState == "GROUP_PURCHASE_ORDER_PLACED"
          ) {
            setTimeout(() => {
              this.$store.commit("saveData", {
                orders: [],
                orderIndex: 0,
                type: "post_order"
              });
              this.$store.commit("saveGroupPerchaseOrder", {
                orderId: this.$route.params.orderId
              });
              this.$cookie.set("orderStatus", "post_order");
              this.$router.replace(
                "/order-history?orderId=" + this.$route.params.orderId
              );
            }, 2000);
          }
          if (
            this.orderDetails.orderState == "GROUP_PURCHASE_ORDER_PLACED" &&
            this.$store.getters.groupPerchaseOrder != this.$route.params.orderId
          ) {
            const obj = {
              groupId: this.orderDetails.groupId
            };
            this.$store
              .dispatch({
                type: "getGroupNotify",
                payload: obj
              })
              .then(data => {});
            try {
              JSBridgePlugin.shoppingGroupPurchase(
                this.orderDetails.groupId,
                this.orderDetails.groupChatMessage
              );
            } catch (err) {
              console.log(err);
            }
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    goToProductDetail(productSrId, type) {
      this.loading = false;
      this.$cookie.delete("type");
      this.$cookie.set("type", type);
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/detail/" + productSrId);
    }
  },
  mounted() {
    if (this.$route.params.orderId) {
      this.getOdersByOrderId();
    }
  }
};
</script>
